import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

const CardLink = ({ children, className, externalUrl, linkPath }) => {
  const linkClassName = classnames(className, 'flex flex-1 flex-col group');

  if (externalUrl)
    return (
      <a
        href={externalUrl}
        target="_blank"
        rel="nofollow noopener noreferrer"
        className={linkClassName}
      >
        {children}
      </a>
    );

  return (
    <Link to={linkPath} className={linkClassName}>
      {children}
    </Link>
  );
};

export default CardLink;
